import { formatDate } from '@/helper'

export default {
  getData (state) {
    const data = state.data

    return data.map(item => {
      const textPrice = Number(item.salePrice) ? `Скидка - ${item.salePrice}` : item.price

      return {
        ...item,
        price: Number(item.salePrice) || Number(item.price),
        categoryName: item?.category?.title || 'Нет категории',
        createdAt: formatDate(item.createdAt),
        titleWithCodeCountPrice: `${item.count} : ${item.title}(${item.code}) - ${textPrice} р.`,
        titleWithCodePrice: `${item.title}(${item.code}) - ${textPrice} р.`,
      }
    })
  },
  getDataObject (_state, getters) {
    return getters.getData.reduce((acc, item) => {
      acc[item.id] = item

      return acc
    }, {})
  },
  getDataObjectByCode (_state, getters) {
    return getters.getData.reduce((acc, item) => {
      acc[item.code] = item

      return acc
    }, {})
  }
}